import * as types from '~/store/mutation-types'

export default function setPageNavigationStart({ store }) {
  store.commit(types.SET_PAGE_NAVIGATION_IN_PROGRESS_STATE, true)
}
